import React from "react";
import AudioPlayer from "../AudioPlayer";
import { Wrapper, InfoWrapper, Content, StyledImage } from "./style";
import { Loader } from "../../style/shared";

const TheBurningGlassHeaderSection = ({ content }) => (
  <Wrapper>
    <InfoWrapper>
      {/* <AudioPlayer
        fixed={false}
        streamUrl={"/audio/the_night_song.m4a"}
        trackTitle={"'The Night Song'"}
      />*/}
      <Content>
        {content()}
        <div className="the-burning-glass">
          <h2>
            Preview 3 songs from the upcoming album
            <br /> — Child and Wattle Tree / Dark Gift / The Watcher
          </h2>
          <ul>
            <li>
              <a
                href="https://nausicaa-music.bandcamp.com/album/child-and-wattle-tree-dark-gift-the-watcher"
                target="_blank"
              >
                Bandcamp
              </a>
            </li>
            <li>
              <a
                href="https://music.apple.com/au/album/child-and-wattle-tree-dark-gift-the-watcher-single/1850647359"
                target="_blank"
              >
                Apple Music
              </a>
            </li>
            <li>
              <a
                href="https://open.spotify.com/album/12MiUANZ2WzSYjMjcAn1Iy"
                target="_blank"
              >
                Spotify
              </a>
            </li>
          </ul>

          <div className="sub">
            <p>released October 31, 2025</p>
            <p>
              Words by Judith Wright <br />
              Music by Simon Munro <br />
              Produced by Greg Walker
            </p>
            <p>
              Mixed by Adam Selzer <br /> Mastered by William Bowden
            </p>
            <p>
              All songs to appear on the upcoming album, The Burning Glass.{" "}
            </p>
          </div>
        </div>
      </Content>
    </InfoWrapper>
    <StyledImage
      src="/images/the-burning-glass-bg/tgb_bg.webp"
      alt="Background Image"
      loader={({ isLoaded }) => <Loader isLoaded={isLoaded} />}
      sources={[
        {
          srcset: [
            "/images/the-burning-glass-bg/tbg_bg.avif 1x",
            "/images/the-burning-glass-bg/tbg_bg@2x.avif 2x",
            "/images/the-burning-glass-bg/tbg_bg.webp 1x",
            "/images/the-burning-glass-bg/tbg_bg@2x.webp 2x",
            "/images/the-burning-glass-bg/tbg_bg.jpg 1x",
            "/images/the-burning-glass-bg/tbg_bg@2x.jpg 2x",
          ],
        },
      ]}
    />
  </Wrapper>
);

export default TheBurningGlassHeaderSection;



// WEBPACK FOOTER //
// ./src/components/TheBurningGlassHeaderSection/index.js